// work data

export const Work = [
	{
		id: 1,
		name: "Weather App",
		description:
			"Aliqua error consectetuer vero, eget vulputate, eros cupidatat vitae nisi.",
		tags: ["react", "gsap", "styledComponents"],

		demo: "https://react-weather-dd.netlify.app/",
		github: "https://github.com/dearlydebbie/Weather-react",
	},
	{
		id: 2,
		name: "Mini Portfolio",
		description:
			"Aliqua error consectetuer vero, eget vulputate, eros cupidatat vitae nisi.",
		tags: ["react", "sass"],

		demo: "https://debbies-portfolio.netlify.app/",
		github: "https://github.com/dearlydebbie/Portfolio",
	},
	{
		id: 3,
		name: "Dictionary App",
		description:
			"Aliqua error consectetuer vero, eget vulputate, eros cupidatat vitae nisi.",
		tags: ["react", "api", "sass"],

		demo: "http://debbies-dictionary.netlify.app/",
		github: "https://github.com/dearlydebbie/dictionary",
	},
	{
		id: 4,
		name: "Quiz App",
		description:
			"Aliqua error consectetuer vero, eget vulputate, eros cupidatat vitae nisi.",
		tags: ["react", "styledComponents", "react-router"],

		demo: "https://debbies-quiz-app.netlify.app/",
		github: "https://github.com/dearlydebbie/quiz-app",
	},
	{
		id: 5,
		name: "Mini Weather App)",
		description:
			"Aliqua error consectetuer vero, eget vulputate, eros cupidatat vitae nisi.",
		tags: ["bootstrap"],

		demo: "http://debbies-weather-app.netlify.app/",
		github: "https://github.com/dearlydebbie/debbies-weather-app",
	},
	{
		id: 6,
		name: "Calculator",
		description:
			"Aliqua error consectetuer vero, eget vulputate, eros cupidatat vitae nisi.",
		tags: ["react", "react-router", "css"],

		demo: "http://js-calcltr.netlify.app/",
		github: "https://github.com/dearlydebbie/JS-Calculator",
	},
	{
		id: 7,
		name: "Tic Tac Toe",
		description:
			"Aliqua error consectetuer vero, eget vulputate, eros cupidatat vitae nisi.",
		tags: ["react", "react-router", "css"],

		demo: "http://tiictacctoe.netlify.app/",
		github: "https://github.com/dearlydebbie/TicTacToe",
	},
	{
		id: 8,
		name: "Tip Calculator",
		description:
			"Aliqua error consectetuer vero, eget vulputate, eros cupidatat vitae nisi.",
		tags: ["react", "react-router", "css"],

		demo: "http://vtip-calc.netlify.app/",
		github: "https://github.com/dearlydebbie/Tip-Calc",
	},
];
